import FormControl from '@mui/material/FormControl';
import FormHelperText, {
  formHelperTextClasses,
} from '@mui/material/FormHelperText';
import FormLabel, { formLabelClasses } from '@mui/material/FormLabel';
import { styled } from '@mui/material/styles';

import {
  FIELD_LABEL_ASTERISK_GAP_PX,
  FIELD_LABEL_TYPOGRAPHY,
  FIELD_STACK_GAP_PX,
  FIELD_VALUE_TYPOGRAPHY,
} from 'theme/components/field-geometry';
import type { InputControlSize } from 'ui/forms/input-control/input-control.types';

interface FieldSizeOwnerState {
  fieldSize: InputControlSize;
}

const shouldForwardProp = (prop: PropertyKey) => prop !== 'fieldSize';

export const InputControlRoot = styled(FormControl)({
  display: 'flex',
  gap: FIELD_STACK_GAP_PX,
});

export const InputControlLabel = styled(FormLabel, {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ theme, fieldSize }) => ({
  ...theme.typography[FIELD_LABEL_TYPOGRAPHY[fieldSize]],
  color: theme.palette.text.primary,
  [`&.${formLabelClasses.focused}, &.${formLabelClasses.error}, &.${formLabelClasses.disabled}`]:
    {
      color: theme.palette.text.primary,
    },
}));

export const InputControlAsterisk = styled('span', {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ theme, fieldSize }) => ({
  marginLeft: FIELD_LABEL_ASTERISK_GAP_PX[fieldSize],
  color: theme.palette.error.main,
}));

export const InputControlSupportiveText = styled('p', {
  shouldForwardProp,
})<FieldSizeOwnerState>(({ theme, fieldSize }) => ({
  ...theme.typography[FIELD_VALUE_TYPOGRAPHY[fieldSize]],
  margin: 0,
  color: theme.palette.text.primary,
}));

export const InputControlMessage = styled(FormHelperText)(({ theme }) => ({
  ...theme.typography.body2,
  margin: 0,
  color: theme.palette.text.primary,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: theme.palette.text.primary,
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: theme.palette.error.main,
  },
}));
